import { Requester } from './Requester';
import { IManifest } from '../types';

export const GetManifestOrganizationById = async ({
    orgId,
    manifest
}: {
    orgId: string;
    manifest: string[];
}): Promise<IManifest | null> => {
    const stringManifest = JSON.stringify(manifest);

    try {
        const response = await Requester<IManifest>({
            // port: '8080',
            path: `organizations/${orgId}?manifest=${window.btoa(stringManifest)}`,
            method: 'GET'
        });

        return response ? (response as IManifest) : null;
        // return Object.hasOwn(response, '_id') ? (response as IContactRecord) : null;
    } catch (e) {
        console.error('Get manifest organization request failed');
        return Promise.reject(e);
    }
};
